var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout converter-layout rtl-layout font-kaznet"},[_c('navigation'),_c('div',{staticClass:"fixed-forgrid"},[_vm._t("default")],2),_c('qaz-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }